import { takeUntil } from 'rxjs/operators';

import { Directive, inject, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';

import { Store } from '@ngxs/store';

import { DisplaySnackbar } from '@shared/states/dialog.actions';
import { LifecycleHooks } from '@shared/services/lifecycle-hooks.service';

@Directive({
  selector: '[zefCopyToClipboard]',
  providers: [LifecycleHooks],
  standalone: false,
})
export class CopyToClipboard extends CdkCopyToClipboard implements OnInit {
  readonly lh = inject(LifecycleHooks);

  readonly store = inject(Store);

  @Input('zefCopyToClipboard')
  text: string;

  @Input()
  copyToClipboardNotice?: string | TemplateRef<any>;

  @Input()
  copyToClipboardActionName?: string;

  @Input()
  copyToClipboardAction?: () => any;

  @Output()
  readonly copiedToClipboard = this.copied;

  ngOnInit(): void {
    this.copied.pipe(takeUntil(this.lh.destroy)).subscribe(() => {
      const noticeTemplate = typeof this.copyToClipboardNotice !== 'string' && this.copyToClipboardNotice;
      const noticeTitle = typeof this.copyToClipboardNotice === 'string' && this.copyToClipboardNotice;

      this.store.dispatch(
        new DisplaySnackbar(noticeTitle, {
          actionName: this.copyToClipboardActionName || void 0,
          actionCallback: this.copyToClipboardAction,
          noticeTemplate,
          color: 'primary',
        }),
      );
    });
  }

  copy(attempts?: number): void {
    super.copy(attempts);
  }
}
